const ChartBullet = ({ primary = '#4711B2', secondary = '#FF9626' }) => (
  <svg width="60" height="54" viewBox="0 0 60 54" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 1C0 0.447716 0.447715 0 1 0H59C59.5523 0 60 0.447715 60 1V13C60 13.5523 59.5523 14 59 14H0.999999C0.447714 14 0 13.5523 0 13V1Z" fill={primary} />
    <path d="M0 41C0 40.4477 0.447715 40 1 40H59C59.5523 40 60 40.4477 60 41V53C60 53.5523 59.5523 54 59 54H0.999999C0.447714 54 0 53.5523 0 53V41Z" fill={primary} />
    <path d="M0 21C0 20.4477 0.447715 20 1 20H59C59.5523 20 60 20.4477 60 21V33C60 33.5523 59.5523 34 59 34H0.999999C0.447714 34 0 33.5523 0 33V21Z" fill={primary} />
    <path d="M0 4H50V10H0V4Z" fill={secondary} />
    <path d="M0 44H35V50H0V44Z" fill={secondary} />
    <path d="M0 24H20V30H0V24Z" fill={secondary} />
  </svg>
);

export default ChartBullet;
